module.exports = __webpack_public_path__ + "img/covid.9b2850ab.jpg";